export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      deliveryType_noticeType_rel:[
        {
          deliveryTypeMstUuid: "deliverytypemst007",
          deliveryTypeName: "メールマガジン",
          deliveryType: "mailmag",
          noticeTypeInfo:[
            {
              noticeTypeMstUuid: "noticeType001",
              noticeTypeName: "テキストのみ",
              noticeType:"text",
            },
          ]
        },
        {
          deliveryTypeMstUuid: "deliverytypemst006",
          deliveryTypeName: "警戒告知",
          deliveryType: "keikai",
          noticeTypeInfo:[
            {
              noticeTypeMstUuid: 'noticeType012',
              noticeTypeName: '警戒レベル告知',
              noticeType: 'keikai',
            },
          ]
        },
        {
          deliveryTypeMstUuid: "deliverytypemst005",
          deliveryTypeName: "御用聞き",
          deliveryType: "ordertake",
          noticeTypeInfo:[
            {
              noticeTypeMstUuid: 'noticeType011',
              noticeTypeName: '御用聞き',
              noticeType: 'ordertake',
            },
          ]
        },
        {
          deliveryTypeMstUuid: "deliverytypemst004",
          deliveryTypeName: "見守り",
          deliveryType: "follow",
          noticeTypeInfo:[
            {
              noticeTypeMstUuid: 'noticeType010',
              noticeTypeName: '見守り',
              noticeType: 'follow',
            },
          ]
        },
        {
          deliveryTypeMstUuid: "deliverytypemst003",
          deliveryTypeName: "サイネージ",
          deliveryType: "signage",
          noticeTypeInfo:[
            {
              noticeTypeMstUuid: 'noticeType008',
              noticeTypeName: '画像のみ',
              noticeType: 'images',
            },
            {
              noticeTypeMstUuid: 'noticeType007',
              noticeTypeName: '音声定時放送',
              noticeType: 'sound_broadcast',
            },
            {
              noticeTypeMstUuid: 'noticeType006',
              noticeTypeName: 'アンケート',
              noticeType: 'opinionaire',
            },
            {
              noticeTypeMstUuid: 'noticeType005',
              noticeTypeName: '音声告知',
              noticeType: 'sound',
            },
            {
              noticeTypeMstUuid: 'noticeType004',
              noticeTypeName: 'PDF',
              noticeType: 'pdf',
            },
            {
              noticeTypeMstUuid: 'noticeType003',
              noticeTypeName: '動画添付',
              noticeType: 'text_movie',
            },
            {
              noticeTypeMstUuid: 'noticeType002',
              noticeTypeName: '画像添付',
              noticeType: 'text_image',
            },
            {
              noticeTypeMstUuid: "noticeType001",
              noticeTypeName: "テキストのみ",
              noticeType:"text",
            },
          ]
        },
        {
          deliveryTypeMstUuid:"deliverytypemst002",
          deliveryTypeName: "家族のお知らせ",
          deliveryType:"family_info",
          noticeTypeInfo:[
            {
              noticeTypeMstUuid: 'noticeType005',
              noticeTypeName: '音声告知',
              noticeType: 'sound',
            },
            {
              noticeTypeMstUuid: 'noticeType003',
              noticeTypeName: '動画添付',
              noticeType: 'text_movie',
            },
            {
              noticeTypeMstUuid: 'noticeType002',
              noticeTypeName: '画像添付',
              noticeType: 'text_image',
            },
            {
              noticeTypeMstUuid: "noticeType001",
              noticeTypeName: "テキストのみ",
              noticeType:"text",
            },
          ]
        },
        {
          deliveryTypeMstUuid:"deliverytypemst001",
          deliveryTypeName: "お知らせ",
          deliveryType:"normal",
          noticeTypeInfo:[
            {
              noticeTypeMstUuid: 'noticeType007',
              noticeTypeName: '音声定時放送',
              noticeType: 'sound_broadcast',
            },
            {
              noticeTypeMstUuid: 'noticeType006',
              noticeTypeName: 'アンケート',
              noticeType: 'opinionaire',
            },
            {
              noticeTypeMstUuid: 'noticeType005',
              noticeTypeName: '音声告知',
              noticeType: 'sound',
            },
            {
              noticeTypeMstUuid: 'noticeType004',
              noticeTypeName: 'PDF',
              noticeType: 'pdf',
            },
            {
              noticeTypeMstUuid: 'noticeType003',
              noticeTypeName: '動画添付',
              noticeType: 'text_movie',
            },
            {
              noticeTypeMstUuid: 'noticeType002',
              noticeTypeName: '画像添付',
              noticeType: 'text_image',
            },
            {
              noticeTypeMstUuid: "noticeType001",
              noticeTypeName: "テキストのみ",
              noticeType:"text",
            },
          ]
        }
      ]
    }
  }
}